export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-sv-SE.f07bda59.xlsx";